<template>
    <div class="container-fluid" style="min-width: 800px;">
        <!--Invoice-->
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card">
                    <form @submit.prevent="handleSubmit" class="form-horizontal">

                        <div class="card-header border-bottom">
                            <h4 class="card-title">Create New Invoice</h4>
                            <h6 class="card-subtitle">Please keep your profile information always current in order to
                                help you when you contact us.</h6>
                        </div>
                        <div class="card-body card-blue">
                            <!-- PO -->
                            <div class="row border-bottom">
                                <div class="col-md-12">
                                    <h5 class="card-title">Purchase Order</h5>
                                    <h6 class="card-subtitle">Select Purcahse Order</h6>
                                    <hr>
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Purchase
                                            Order:</label>
                                        <div class="col-sm-3">
                                            <multiselect
                                                    :class="{'is-invalid': submitted && errors.has('po')}"
                                                    :clear-on-select="false"
                                                    :close-on-select="true"
                                                    :hide-selected="true"
                                                    :internal-search="false"
                                                    :limit="3"
                                                    :loading="isLoading"
                                                    :max-height="600"
                                                    :options="pos"
                                                    :options-limit="300"
                                                    :searchable="true"
                                                    :show-no-results="false"
                                                    @input="setpodate"
                                                    @search-change="searchPO"
                                                    class="form-control"
                                                    data-vv-as="PO"
                                                    id="po"
                                                    name="po"
                                                    open-direction="bottom"
                                                    placeholder="Search Purchase Orders"
                                                    track-by="id"
                                                    v-model="invoice.po"
                                                    v-validate="">
                                                <template slot="singleLabel" slot-scope="props">
                                                    <div class="option__desc">
                                                        <div class="option__desc">
                                                            PO #{{ props.option.po_number }}
                                                        </div>
                                                    </div>
                                                </template>
                                                <template slot="option" slot-scope="props">
                                                    <div class="option__desc">
                                                        <div class="option__desc" v-if="props.option">
                                                            <h5>PO #{{ props.option.po_number }}</h5>
                                                            <h6>Created At: {{ props.option.created_at | medium }}</h6>
                                                        </div>
                                                        <div class="option__desc" v-else>
                                                            <h5>Add New</h5>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template slot="afterList">
                                                    <div class="col-xs-12">
                                                        <router-link :to="{name: 'newpo'}"
                                                                     class="btn btn-block btn-lg btn-outline-success">
                                                            <i class="fa fa-plus-circle"></i>&nbsp;Add Purchase Order
                                                        </router-link>
                                                    </div>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">PO Date:</label>
                                        <div class="col-sm-3">
                                            <input :class="{'is-invalid': submitted && errors.has('po_date')}"
                                                   autocomplete="off"
                                                   class="form-control"
                                                   data-vv-as="po date"
                                                   id="po_date"
                                                   name="po_date"
                                                   placeholder="dd/MM/yyyy"
                                                   readonly
                                                   style="height: 42px;"
                                                   type="date"
                                                   v-model="invoice.po_date"
                                                   v-validate="">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('po_date')">{{
                                                errors.first('po_date') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Due
                                            Date:</label>
                                        <div class="col-sm-3">
                                            <input :class="{'is-invalid': submitted && errors.has('due_date')}"
                                                   autocomplete="off"
                                                   class="form-control"
                                                   data-vv-as="due date"
                                                   id="due_date"
                                                   name="due_date"
                                                   placeholder="dd/MM/yyyy"
                                                   style="height: 42px;"
                                                   type="date"
                                                   v-model="invoice.due_at"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('due_date')">{{
                                                errors.first('due_date') }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Other
                                            Reference:</label>
                                        <div class="col-sm-6">
                                            <textarea :class="{'is-invalid': submitted && errors.has('notes')}"
                                                      autocomplete="off"
                                                      class="form-control"
                                                      data-vv-as="Other reference"
                                                      id="notes"
                                                      name="notes"
                                                      placeholder=""
                                                      rows="5"
                                                      type="text"
                                                      v-model="invoice.notes"></textarea>
                                            <div class="invalid-feedback" v-if="submitted && errors.has('notes')">{{
                                                errors.first('notes') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Buyer -->
                            <div class="row border-bottom">
                                <div class="col-md-12">
                                    <h5 class="card-title mt-3">Buyer</h5>
                                    <h6 class="card-subtitle">Select Buyer and Shipping Address</h6>
                                    <hr>
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Bill To:</label>
                                        <div class="col-sm-6">
                                            <multiselect
                                                    :class="{'is-invalid': submitted && errors.has('partner')}"
                                                    :clear-on-select="false"
                                                    :close-on-select="true"
                                                    :hide-selected="true"
                                                    :internal-search="false"
                                                    :limit="3"
                                                    :loading="isLoading"
                                                    :max-height="600"
                                                    :options="partners"
                                                    :options-limit="300"
                                                    :searchable="true"
                                                    :show-no-results="false"
                                                    @input="setAddress"
                                                    @search-change="searchPartners"
                                                    class="form-control"
                                                    data-vv-as="partner"
                                                    id="partner"
                                                    label="partner"
                                                    name="partner"
                                                    open-direction="bottom"
                                                    placeholder="Search Partners"
                                                    track-by="id"
                                                    v-model="invoice.partner"
                                                    v-validate="'required'">
                                                <template slot="singleLabel" slot-scope="props">
                                                    <div class="option__desc">
                                                        <div class="option__desc">
                                                            {{ props.option.org_name }}
                                                        </div>
                                                    </div>
                                                </template>
                                                <template slot="option" slot-scope="props">
                                                    <div class="option__desc">
                                                        <div class="option__desc" v-if="props.option">
                                                            <h5>{{ props.option.org_name }}</h5>
                                                            <!--                                                            <h6>{{ props.option.line1}}</h6>-->
                                                            <!--                                                            <h6>{{ props.option.city+', '+ props.option.country}}</h6>-->
                                                        </div>
                                                        <div class="option__desc" v-else>
                                                            <h5>Add New</h5>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template slot="afterList">
                                                    <div class="col-xs-12">
                                                        <router-link :to="{name: 'addbuyer'}"
                                                                     class="btn btn-block btn-lg btn-outline-success">
                                                            <i class="fa fa-plus-circle"></i>&nbsp;Add Customer
                                                        </router-link>
                                                    </div>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Currency:</label>
                                        <div class="col-sm-6">
                                            <div :class="{'is-invalid': submitted && errors.has('currency')}"
                                                 class="form-control p-0-0">
                                                <currency-select @currency-select="setCurrency"
                                                                 data-vv-as="currency"
                                                                 id="currency"
                                                                 name="currency"
                                                                 ref="reference"
                                                                 v-model="invoice.currency.id"
                                                                 v-validate="'required'">
                                                </currency-select>
                                            </div>
                                            <div class="invalid-feedback" v-if="submitted && errors.has('currency')">{{
                                                errors.first('currency')
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Address:</label>
                                        <div class="col-sm-10">
                                            <div class="form-check mt-2">
                                                <input class="form-check-input " id="defadd" type="checkbox"
                                                       v-model="defadd">
                                                <label class="form-check-label" for="defadd">Buyer Default
                                                    Address</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 offset-2 mt-2">
                                            <input :class="{'is-invalid': submitted && errors.has('line1')}"

                                                   class="form-control"
                                                   data-vv-as="Line 1"
                                                   id="line1"
                                                   name="line1"
                                                   placeholder="Line 1"
                                                   type="text"
                                                   v-model="address.line1"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('line1')">{{
                                                errors.first('line1') }}
                                            </div>
                                        </div>
                                        <div class="col-sm-6 offset-2 mt-3">
                                            <input :class="{'is-invalid': submitted && errors.has('line2')}"

                                                   class="form-control"
                                                   data-vv-as="Line 2"
                                                   id="line2"
                                                   name="line2"
                                                   placeholder="Line 2"
                                                   type="text"
                                                   v-model="address.line2"
                                                   v-validate="">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('line2')">{{
                                                errors.first('line2') }}
                                            </div>
                                        </div>
                                        <div class="col-sm-3 offset-2 mt-3">
                                            <input :class="{'is-invalid': submitted && errors.has('city')}"

                                                   class="form-control"
                                                   data-vv-as="City"
                                                   id="city"
                                                   name="city"
                                                   placeholder="City"
                                                   type="text"
                                                   v-model="address.city"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('city')">{{
                                                errors.first('city') }}
                                            </div>
                                        </div>
                                        <div class="col-sm-3 mt-3">
                                            <input :class="{'is-invalid': submitted && errors.has('state')}"

                                                   class="form-control"
                                                   data-vv-as="state"
                                                   id="state"
                                                   name="state"
                                                   placeholder="State"
                                                   type="text"
                                                   v-model="address.state"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('state')">{{
                                                errors.first('state') }}
                                            </div>
                                        </div>
                                        <div class="col-sm-3 offset-2 mt-3">
                                            <input :class="{'is-invalid': submitted && errors.has('zip')}"

                                                   class="form-control"
                                                   data-vv-as="zip"
                                                   id="zip"
                                                   name="zip"
                                                   placeholder="Zip"
                                                   type="text"
                                                   v-model="address.zip"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('zip')">{{
                                                errors.first('zip') }}
                                            </div>
                                        </div>
                                        <div class="col-sm-3 mt-3">
                                            <input :class="{'is-invalid': submitted && errors.has('country')}"

                                                   class="form-control"
                                                   data-vv-as="country"
                                                   id="country"
                                                   name="country"
                                                   placeholder="Country"
                                                   type="text"
                                                   v-model="address.country"
                                                   v-validate="'required'">
                                            <div class="invalid-feedback" v-if="submitted && errors.has('country')">{{
                                                errors.first('country') }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Items -->
                            <div class="row border-bottom">
                                <div class="col-md-12">
                                    <h5 class="card-title mt-3">Items</h5>
                                    <h6 class="card-subtitle">Invoice items</h6>
                                    <hr>
                                    <div class="table-responsive">
                                        <table class="table v-middle invoice">
                                            <thead>
                                            <tr class="bg-light">
                                                <th class="border-top-0"></th>
                                                <th class="border-top-0">Goods &amp; Services</th>
                                                <th class="border-top-0">Code</th>
                                                <th class="border-top-0">Unit</th>
                                                <th class="border-top-0">Quantity</th>
                                                <th class="border-top-0">Rate</th>
                                                <th class="border-top-0 text-right amount-col" style="width: 150px;">
                                                    Amount
                                                </th>
                                                <th class="border-top-0"></th>
                                            </tr>
                                            </thead>

                                            <invoice-line-item
                                                    :currency="invoice.currency"
                                                    :events="events"
                                                    :index="index"
                                                    :key="item.id"
                                                    :lineitem="item"
                                                    :marketplaceid="marketplaceid"
                                                    :org-taxes="orgTaxes"
                                                    v-for="(item, index) in invoice.items">
                                            </invoice-line-item>

                                            <tbody>
                                            <tr>
                                                <td class="text-center" colspan="8">
                                                    <button data-target="#searchAndSelectCommodityModal" data-toggle="modal"
                                                            class="btn btn-dropbox waves-effect waves-light"
                                                            type="button">
                                                        <i class="fas fa-plus"></i> Add Goods/Services
                                                    </button>
                                                </td>
                                            </tr>
                                            </tbody>

                                            <tbody class="total">
                                            <tr>
                                                <td class="text-right no-border" colspan="6">
                                                    <h5>Subtotal</h5>
                                                </td>
                                                <td class="no-border text-right">
                                                    <h5 class="text-right">{{invoice.currency.symbol}}
                                                        {{subtotal.formatted}}</h5>
                                                </td>
                                                <td class="no-border icon-col"></td>
                                            </tr>
                                            <tr v-for="t in taxAmounts">
                                                <td class="text-right no-border" colspan="6">
                                                    <h5>{{t.name}}</h5>
                                                </td>
                                                <td class="no-border text-right">
                                                    <h5>{{invoice.currency.symbol}} {{t.sumFormatted}}</h5>
                                                </td>
                                                <td class="no-border icon-col"></td>
                                            </tr>
                                            <tr>
                                                <td class="text-right no-border" colspan="6">
                                                    <h5>Total</h5>
                                                </td>
                                                <td class="no-border text-right">
                                                    <h5>{{invoice.currency.symbol}} {{total.formatted}}</h5>
                                                </td>
                                                <td class="no-border icon-col"></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <!-- Payment terms -->
                            <div class="row">
                                <div class="col-md-12">
                                    <h5 class="card-title mt-3">Payment Terms</h5>
                                    <h6 class="card-subtitle">Payment Terms and Bank Account</h6>
                                    <hr>
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Payment
                                            Term:</label>
                                        <div class="col-sm-6">
                                            <textarea autocomplete="off"
                                                      class="form-control"
                                                      data-vv-as="term"
                                                      id="term"
                                                      name="term"
                                                      placeholder="Payment terms"
                                                      rows="5"
                                                      v-model="terms.term"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Bank
                                            Name:</label>
                                        <div class="col-sm-6">
                                            <div class="form-check mt-2">
                                                <input class="form-check-input " id="defbank" type="checkbox"
                                                       v-model="defbank">
                                                <label class="form-check-label" for="defbank">Seller Default
                                                    Bank</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 offset-2 mt-2">
                                            <input autocomplete="off"
                                                   class="form-control"
                                                   data-vv-as="bank"
                                                   id="bank"
                                                   name="bank"
                                                   placeholder="Bank Name"
                                                   type="text"
                                                   v-model="terms.account.bank"
                                            >
                                        </div>
                                        <div class="col-sm-6 offset-2 mt-2">
                                            <textarea autocomplete="off"
                                                      class="form-control"
                                                      data-vv-as="address"
                                                      id="address"
                                                      name="address"
                                                      placeholder="Bank address"
                                                      rows="5"
                                                      v-model="terms.account.address"
                                            ></textarea>
                                        </div>
                                        <div class="col-sm-6 offset-2 mt-2">
                                            <input autocomplete="off"
                                                   class="form-control"
                                                   data-vv-as="ac"
                                                   id="ac"
                                                   name="ac"
                                                   placeholder="Account no"
                                                   type="text"
                                                   v-model="terms.account.ac"
                                            >
                                        </div>
                                        <div class="col-sm-6 offset-2 mt-2">
                                            <input autocomplete="off"
                                                   class="form-control"
                                                   data-vv-as="ifsc"
                                                   id="ifsc"
                                                   name="ifsc"
                                                   placeholder="IFSC code"
                                                   type="text"
                                                   v-model="terms.account.ifsc"
                                            >
                                        </div>
                                        <div class="col-sm-6 offset-2 mt-2">
                                            <input autocomplete="off"
                                                   class="form-control"
                                                   data-vv-as="ifsc"
                                                   id="swift"
                                                   name="swift"
                                                   placeholder="Swift code"
                                                   type="text"
                                                   v-model="terms.account.swift"
                                            >
                                        </div>
                                        <div class="col-sm-6 offset-2 mt-2">
                                            <input autocomplete="off"
                                                   class="form-control"
                                                   data-vv-as="micr"
                                                   id="micr"
                                                   name="micr"
                                                   placeholder="MICR code"
                                                   type="text"
                                                   v-model="terms.account.micr"
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-6 offset-6 text-right">
                                    <div class="button-group">
                                        <!--                                        <button @click="preview()" class="btn waves-effect waves-light btn-secondary" type="button">Preview</button>-->
                                        <button class="btn waves-effect waves-light btn-secondary btn-success"
                                                type="submit" v-bind:disabled="invoice.items.length === 0">Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <search-select-commodity :checked-commodity-ids="commodityIds"
                                 @commodity-select="setCommodity"></search-select-commodity>
    </div>
</template>

<script>
    import _ from 'lodash';
    import Vue from "vue";
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect';
    import {BigNumber} from "bignumber.js";
    import Blockie from '../../common/Blockie';
    import CurrencySelect from "../../../protected/common/CurrencySelect";
    import InvoiceLineItem from "./MarketplaceInvoiceLineItem";
    import SearchSelectCommodity from "../../common/SearchSelectCommodity";

    export default {
        name: "NewInvoice",
        components: {SearchSelectCommodity, Blockie, Multiselect, CurrencySelect, InvoiceLineItem},
        data() {
            return {
                events: new Vue(),
                submitted: false,
                marketplaceid: '',
                isLoading: false,
                isLoadingGs: false,
                orgImg: null,
                orgTaxes: [],
                partners: [],
                sales: [],
                pos: [],
                defadd: false,
                others: false,
                invoice: {
                    po: null,
                    po_date: null,
                    number: '',
                    partner: null,
                    issue_at: null,
                    due_at: null,
                    items: [],
                    total: '',
                    currency: {
                        id: null,
                        name: null,
                        symbol: null
                    }
                },
                address: {
                    line1: null,
                    line2: null,
                    city: null,
                    state: null,
                    zip: null,
                    country: null
                },
                terms: {
                    term: null,
                    account: {
                        bank: null,
                        address: null,
                        ac: null,
                        ifsc: null,
                        swift: null,
                        micr: null
                    }
                },
                adjst_types: ['DISCOUNT', 'ADJUSTMENT'],
                adjustment: {
                    index: null,
                    type: null,
                    value: null
                },
                defbank: false,
                bank: {},
                commodityIds: []
            };
        },
        watch: {
            "defadd": function (nv, ov) {
                if (nv && this.invoice.partner) {
                    this.address = {
                        line1: this.invoice.partner.line1,
                        line2: this.invoice.partner.line2,
                        city: this.invoice.partner.city,
                        state: this.invoice.partner.state,
                        zip: this.invoice.partner.postal_code,
                        country: this.invoice.partner.country
                    }
                } else {
                    this.address = {
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        zip: null,
                        country: null
                    }
                }
            },
            "defbank": function (nv, ov) {
                if (nv) {
                    this.terms.account = {
                        bank: this.bank.name,
                        address: this.bank.address,
                        ac: this.bank.ac,
                        ifsc: this.bank.ifsc,
                        swift: this.bank.swift,
                        micr: this.bank.micr
                    }
                } else {
                    this.terms.account = {
                        bank: null,
                        address: null,
                        ac: null,
                        ifsc: null,
                        swift: null,
                        micr: null
                    }
                }
            }
        },
        computed: {
            ...mapGetters(["currentUser", "currentOrg"]),

            /**
             * Computes sum of line items without taxes.
             * @returns {string}
             */
            subtotal: function () {
                let subtotal = new BigNumber(0);

                _.forEach(this.invoice.items, item => {
                    let amount = new BigNumber(item.quantity)
                        .multipliedBy(new BigNumber(item.rate));

                    let reductions = BigNumber.sum.apply(null, _.map(item.reductions, "amount"));

                    if (!reductions.isNaN()) {
                        amount = amount.minus(reductions);
                    }

                    if (amount.isNaN()) {
                        return subtotal;
                    }

                    subtotal = subtotal.plus(amount);
                });

                return {
                    value: subtotal,
                    formatted: subtotal.toFormat(2)
                };
            },

            /**
             * Computes tax amounts
             */
            taxAmounts: function () {
                let taxes = [];
                _.forEach(this.invoice.items, item => {
                    _.forEach(item.taxes, t => {
                        if (!_.isObject(t.tax)) {
                            return;
                        }
                        taxes.push(t.tax);
                    });
                });

                let taxGroups = _.groupBy(taxes, "name");

                return _.map(taxGroups, (taxObjs, name) => {
                    let sum = BigNumber.sum.apply(null, _.map(taxObjs, "amount"));

                    if (sum.isNaN()) {
                        sum = new BigNumber(0);
                    }

                    return {
                        name,
                        sum,
                        sumFormatted: sum.toFormat(2)
                    };
                });
            },

            /**
             * Sum of subtotal and all taxes
             */
            total: function () {
                let total = new BigNumber(this.subtotal.value);
                _.forEach(this.taxAmounts, t => {
                    total = total.plus(t.sum);
                });

                if (total.isNaN()) {
                    total = new BigNumber(0);
                }

                return {
                    value: total,
                    formatted: total.toFormat(2)
                };
            }
        },
        created() {
            this.events.$on('invoice:removeitem', index => {
                this.removeRow(index);
            });
        },
        mounted() {
            this.init();
            this.marketplaceid = this.currentOrg.marketplace_id;

        },
        methods: {
            async init() {
                await Promise.all([
                    this.getOrgTaxes(),
                    this.getOrg(),
                    this.getAttachment(),
                    this.getInvoiceNumber()
                ])
            },

            //
            // Following are called to populate the invoice form
            //

            async getInvoiceNumber() {
                let reply = await this.$http.get(`marketplace/${this.marketplaceid}/invoices/suggest/number`);
                this.invoice.number = reply.data.number;
            },
            async getOrg() {
                let reply = await this.$http.get("/org/" + this.currentOrg.id + "/profile");
                this.bank = reply.data.bank || {};
                this.defbank = true;
            },

            async getAttachment() {
                let attachments = await this.$http.get(`/org/${this.currentOrg.id}/attachments`);
                if (attachments.data && attachments.data.length > 0) {
                    this.orgImg = `https://attachments-acrecx.s3.us-east-2.amazonaws.com/${attachments.data[0].filepath}`;
                }
            },
            async searchPO(searchText) {
                try {
                    this.isLoading = true;
                    let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/purchases", {
                        params: {
                            number: searchText
                        }
                    });
                    this.pos = reply.data.purchases;
                    this.isLoading = false;
                } catch (e) {
                    console.log(e);
                }
            },
            async searchPartners(searchText) {
                try {
                    this.isLoading = true;
                    let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.partners = reply.data;
                    this.isLoading = false;
                } catch (e) {
                    console.log(e);
                }
            },
            setCurrency(e) {
                if (e) {
                    this.invoice.currency.id = e.id;
                    this.invoice.currency.name = e.name;
                    this.invoice.currency.symbol = e.symbol;
                }
            },
            addRow() {
                this.invoice.items.push({
                    code: null,
                    goodsSerivces: null,
                    description: '',
                    rate: null,
                    unit: {
                        id: null,
                        symbol: null
                    },
                    amount: null,
                    quantity: null,
                    taxes: [],
                    reductions: [],
                    subtotal: ''
                });
            },
            removeRow(index) {
                this.invoice.items.splice(index, 1);
                this.commodityIds = this.invoice.items.map(item=> item.goodsSerivces.id);
            },

            //
            // Form actions
            //

            handleSubmit(e) {
                this.submitted = true;
                this.events.$emit('invoicelineitem:validate');

                let others = _.filter(this.invoice.items, function (o) {
                    return (o.goodsSerivces && o.goodsSerivces.name === 'OTHERS');
                });

                if (others.length > 1) {
                    this.$toastr('error', 'Only one "OTHERS" item can be added', 'Failed');
                } else {
                    this.$validator.validate()
                        .then(valid => {
                            if (valid) {
                                this.save();
                            }
                        });
                }
            },
            async save() {
                this.invoice.address = this.address;
                this.invoice.terms = this.terms;
                console.log("this.invoice", JSON.stringify(this.invoice));

                try {
                    await this.$http.put("/marketplaces/" + this.currentOrg.marketplace_id + "/invoices", this.invoice);
                    this.$toastr('success', 'Invoiced added', 'Success');
                    await this.$router.push({name: "marketplaceinvoices"});
                } catch (e) {
                    this.$toastr('error', e.response.data.reason, 'Failed');
                }
            },
            preview() {
                console.log("preview");
            },
            setpodate(e) {
                if (e) {
                    this.invoice.po_date = e.created_at.split("T")[0];
                } else {
                    this.invoice.po_date = null;
                }
            },
            setAddress(e) {
                if (e) {
                    this.defadd = true;
                    this.address = {
                        line1: e.line1,
                        line2: e.line2,
                        city: e.city,
                        state: e.state,
                        zip: e.postal_code,
                        country: e.country
                    }
                } else {
                    this.defadd = false;
                    this.address = {
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        zip: null,
                        country: null
                    }
                }
            },
            async getOrgTaxes() {
                let {data} = await this.$http.get(`org/${this.currentOrg.id}/taxes`);
                this.orgTaxes = data;
            },
            setCommodity(e) {
                let commodities = e;
                commodities.forEach(c=> {
                    let found = this.invoice.items.find(row=> row.goodsSerivces.commodity_id === c.id);
                    if(!found){
                        this.invoice.items.push({
                            goods_services_id: c.id,
                            code: c.code,
                            goodsSerivces: c,
                            description: '',
                            rate: c.rate? c.rate.amount : null,
                            unit: {
                                id: c.unit? c.unit.id : null,
                                name: c.unit? c.unit.name : null,
                                symbol: c.unit ? c.unit.symbol : null
                            },
                            amount: null,
                            quantity: null,
                            taxes: [],
                            reductions: [],
                            subtotal: ''
                        });
                    }
                })
                this.commodityIds = commodities.map(c=> c.id);

            }
        }
    }
</script>

<style scoped>
    table td {
        text-align: left;
    }

    table th {
        text-align: left;
    }

    .no-border {
        border-top: 0px;
    }


    .amount-col {
        width: 150px;
    }

    .icon-col {
        width: 25px;
    }

    table tbody.total {
        border-top: 0;
    }

</style>
